import { createAuthClient } from "better-auth/react";
import { API_CONFIG } from "../config/api";

export const authClient = createAuthClient({
	baseURL: API_CONFIG.baseURL,
});

export const { signIn, signUp, signOut, useSession, getSession } = authClient;
